import apiConfig from '../../apiConfig';
export const getDepartmentVersionUnselectedStepList = async (at, versionId) => {
	const response = await apiConfig.post(
		'/API/ADMINISTRATION/DEPARTMENTS/SERVICES/GET_DEPARTMENT_VERSION_UNSELECTED_STEPS_LIST',
        {
            Department_Service_Version_Id :versionId
        }, 
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	if (response.data.Status) {
		for (let i in response.data.Data) {
			if (response.data.Data[i].Service_Step_Send_Notification === 1) {
				response.data.Data[i].Service_Step_Send_Notification = true;
			} else {
				response.data.Data[i].Service_Step_Send_Notification = false;
			}
		}
		return response.data.Data;
	}

	return [];
};
